/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ContactsBody, UpdateSettingsContactsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSettingsContacts: build.mutation<ContactsBody, UpdateSettingsContactsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/settings/contacts`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateSettingsContactsApi };
export const { useUpdateSettingsContactsMutation } = injectedRtkApi;
